/**
 * To prevent circular dependencies, please refrain from importing from requestSelectors.ts and try to keep an object oriented format for your selectors
 */
import {
  createSelector,
  IContactUsState,
  IRequestHistoryState,
  IUITabViewInfo,
} from '../../../../models/reduxState';
import {
  contactStateSelector,
  currentUITabViewInfoSelector
} from '../../../app/selectors/contactUsSelector';
import { FreelanceRequest } from '../../models/requestModels';

export const requestHistorySelector = createSelector(
  contactStateSelector,
  (r: IContactUsState) => r.RequestHistoryState
);

export const allRequestsSelector = createSelector(
  requestHistorySelector,
  (r: IRequestHistoryState) => r.allRequests
);

export const isSearchingRequestsSelector = createSelector(
  requestHistorySelector,
  (r: IRequestHistoryState) => r.isSearchingRequests
);

export const getPristineRequest = (
  uITabViewInfo: IUITabViewInfo,
  allRequests: FreelanceRequest[]
): FreelanceRequest => {
  if (!uITabViewInfo || !uITabViewInfo.requestId) {
    return null;
  }
  const requestId = uITabViewInfo.requestId;
  if (requestId && allRequests && allRequests.length > 0) {
    const request = allRequests.find(
      (r: FreelanceRequest) =>
        r &&
        r.RequestId &&
        r.RequestId.toLowerCase() === requestId.toLowerCase()
      // || r.ParentRequestId
      // && r.ParentRequestId.toLowerCase() === requestId.toLowerCase()
    );
    return request || null;
  }
  return null;
};

export const pristineRequestSelector = createSelector(
  [currentUITabViewInfoSelector, allRequestsSelector],
  getPristineRequest
);
